import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { AppConfigService } from './app-config.service';

@Injectable()
export class CustomPreloadingStatergy implements PreloadingStrategy {
    routeConfigs: any;
    constructor(private authService: AuthService,
        private appConfigService: AppConfigService) { }

    preload(route: Route, load: () => Observable<any>): Observable<any> {
        if (this.authService.dashboardItems && this.authService.dashboardItems.length) {
            // this.routeConfigs[]
            if (!this.routeConfigs) {
                this.routeConfigs = {
                    master: this.authService.dashboardItems.filter(e => e.entityType === 'master'),
                    transaction: this.authService.dashboardItems.filter(e => e.entityType === 'transaction'),
                    report: this.authService.dashboardItems.filter(e => e.entityType === 'report'),
                    admin: this.authService.dashboardItems.filter(e => e.entityType === 'admin')
                };
            }

            if (this.routeConfigs[route.path] && this.routeConfigs[route.path].length) {
                route.data.preload = !!(this.routeConfigs[route.path].length);
            } else if (!this.routeConfigs[route.path] && route.data) {
                const isRouteFound =  this.authService.dashboardItems.find(e => e.ENTRY_ID === route.data.entry_id);
                route.data.preload = !!isRouteFound;
            }


            if (route.data && route.data.preload) {
                return load();
            } else {
                return of(null);
            }
        } else {
            return of(null);
        }
    }
}